export default {"src":"/_next/static/media/no.841baa55.svg","height":24,"width":25};